import { useState } from 'react';
import { SearchBar } from '../../components/search-input/search-bar';
import { SlideHeader } from './slide-header';
import { Back, Logo, Search } from '../../assets/icons';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { queryClient } from '../../index';
import { SERVICE_LIST_QUERY_KEY, useFetch } from '../../hooks/useFetch';

export const HeaderPage = ({isMain}) => {
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();

  const { serviceId } = useParams()


  console.log("serviceId", serviceId);
  const { data: serviceListApi, isLoading: isLoadingService } = useFetch('repair-service',{ queryKey: SERVICE_LIST_QUERY_KEY})




  // const services = serviceListApi?.payload ?? [];

  // const findInServiceName = services.filter(service => {
  //   const serviceName = service.name?.toLowerCase() ?? '';
  //   return serviceName.includes('service');
  // })


  const onSearch = (e) => {
    console.log("onSearch", e);
  }


  const backToHome = () => {
      navigate('')
  };

  const goBack = () => {
    navigate('/service')
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  return (
    <>
      {isMain ? (
        <SlideHeader />
      ) : (

        <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-40 h-[68px]">
          <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-5 lg:px-0 h-full flex items-center justify-between">
            {showSearch ? (
              <div className="w-full flex items-center gap-2">
                <button
                  onClick={toggleSearch}
                  className="sm:hidden flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 text-gray-600"
                >
                  <Back />
                </button>
                <div className="grow">
                  <SearchBar onSearch={onSearch} />
                </div>
              </div>
            ) : (
              <div className="flex items-stretch w-full gap-2 sm:gap-4 md:gap-10 justify-between">
                <button
                  onClick={goBack}
                  className="sm:hidden flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 text-gray-600"
                >
                  <Back className='text-gray-500'/>
                </button>
                <div className='cursor-pointer sm:grow-0 grow flex justify-center sm:justify-start' onClick={backToHome}>
                  <Logo/>
                </div>
                <div className="hidden sm:block grow">
                  <SearchBar onSearch={onSearch} />
                </div>
                <button
                  onClick={toggleSearch}
                  className="sm:hidden flex items-center justify-center w-10 h-10 rounded-full bg-gray-100"
                >
                  <Search className='w-5 h-5 text-gray-500' />
                </button>
              </div>
            )}
          </div>
        </header>
      )}
    </>
  );
};